/* eslint-disable */
YP.TicketingManager = function() {
    var widgetButton           = $('.btn-flat.widget');
    var ticketingSettingsActiveDate = $("#ticketing_setting_active_date");
    var cguDisplayChoice = $('.cgu_display_choice_field input[type=radio]');
    var showMoreFirstOptions = $('.js-ticketing_show-more-first-options');
    var showMoreSecondOptions = $('.js-ticketing_show-more-second-options');
    var showMoreThirdOptions = $('.js-ticketing_show-more-third-options');
    var showMoreFourthOptions = $('.js-ticketing_show-more-fourth-options');
    var showFirstOptions = $('.js-ticketing_show-first-options');
    var showSecondOptions = $('.js-ticketing_show-second-options');
    var showThirdOptions = $('.js-ticketing_show-third-options');
    var showFourthOptions = $('.js-ticketing_show-fourth-options');
    return {
        init: function(){
            showMoreFirstOptions.on('click', function(e){
                var showOptionsIcon = $(this).find('a');
                showFirstOptions.show();
                showOptionsIcon.hide();
            });
            showMoreSecondOptions.on('click', function(e){
                var showOptionsIcon = $(this).find('a');
                showSecondOptions.show();
                showOptionsIcon.hide();
            });
            showMoreThirdOptions.on('click', function(e){
                var showOptionsIcon = $(this).find('a');
                showThirdOptions.show();
                showOptionsIcon.hide();
            });
            showMoreFourthOptions.on('click', function(e){
                var showOptionsIcon = $(this).find('a');
                showFourthOptions.show();
                showOptionsIcon.hide();
            });

            if($("#preview-ticket").length > 0){
                $("#preview-ticket").on("click", this.downloadDefaultTicket);
            }

            if(ticketingSettingsActiveDate.length > 0){
                this.displayActiveDate()
                this.changeEndDate()
            }

            $('.check_max_allowed_registration_per_email input:checkbox').on('click', function() {
                $('.max_allowed_registration_per_email').toggle();
                $('.max_allowed_registration_per_email input').val("");
            });

            this.initWidgetStyleForm();
            widgetButton.live('click', this.displayWidget);
            text =
              '<a class="dropdown-toggle" data-toggle="dropdown" href="#">Ajouter un billet <span class="caret"></span></a>'+
              '<ul class="dropdown-menu">'+
                '<li><a href="' + $('.new-ticket').data('url-ticket') + '">Billet simple</a></li>';


            text += '<li><a href="' + $('.new-ticket').data('url-pack') + '">Pack de billets</a></li>';
            text += '<li><a href="' + $('.new-ticket').data('url-distributor') + '">Billet distributeur</a></li>';
            text += '</ul>';

            $('.new-ticket').empty().html(text);
            $('#tracking-text-generation').on('submit', this.generateLinkSpread);
            $('#copy-generated-link-button').on('click', this.copyGeneratedLink);

            $('#tva_tva_rate').change(function(){
                // Only show the checkbox allowing to display taxfree prices on event page if a VAT percentage has been selected
                if(parseFloat($(this).val()) > 0) {
                    $('#tva_display_ht_prices').parents('.c-form__field_checkbox').show();
                    //Otherwise hide and uncheck the checkbox allowing to show taxfree prices on event page
                } else {
                    $('#tva_display_ht_prices').removeAttr('checked');
                    $('#tva_display_ht_prices').parents('.c-form__field_checkbox').hide();

                }
            }).change();

            $('.td-change-haspayed a').live('click', function(e) {
                var url = $(this).data('url'),
                    payment = $(this).data('payment');

                $('.has-payed-loader').show();
                $('.has-payed-title').hide();
                $.post(url, function(data){
                    var color = '#C1C1C1';
                    if(data.hasPayed) {
                        color = '#96BF48';
                    }
                    $('.'+ payment+' i').css({
                        color: color
                    });
                    $('.has-payed-loader').hide();
                    $('.has-payed-title').show();
                });
                e.preventDefault();
            });

            if (cguDisplayChoice.length > 0){
                this.initCguDisplayChoice();
            }
        },
        displayActiveDate: function(){
            ticketingSettingsActiveDate.on("change", function(e){
                if($(this).is(":checked")){
                    $("#active_date_settings").show()
                }
                else{
                    $("#active_date_settings").hide()
                }
            })
        },
        changeEndDate : function(){
            $("#tva_begin_date").on("change", function(e){
                var end      = $('#tva_end_date');

                var beginVal = moment($(this).val(), 'DD-MM-YYYY');
                var endVal   = moment(end.val(), 'DD-MM-YYYY');

                if (beginVal.unix() > endVal.unix()) {
                    end.val($(this).val());
                }
            })
        },
        downloadDefaultTicket: function(e){
            e.preventDefault();
            var typeTicketId = $("#preview-ticket").attr("data-type-ticket-id");
            var url = $(this).data("url");

            if(typeTicketId != 0){
                url += "?typeTicketId=" + typeTicketId
            }

            window.location.href = url;
        },
        displayWidget : function (e) {
            e.preventDefault();
            widgetButton.toggleClass('active');
            if($(this).hasClass('active')) {
                $('.widget_div').show();
            } else {
                $('.widget_div').hide();
            }
        },
        initSortable : function (e) {
            $(".table-typeticket tbody").sortable({
              handle : '.positionning-handle',
              helper: function(e, tr) {
                  var $originals = tr.children();
                  var $helper = tr.clone();
                  $helper.children().each(function(index) {
                    $(this).width($originals.eq(index).width())
                  });
                  return $helper;
                },
              update : function () {
                var tbody = $(".table-typeticket tbody");
                var order = tbody.sortable('serialize');
                $.post($(this).data('sorturl'), { order: order});
              }
            });
        },
        generateLinkSpread : function(e) {
            e.preventDefault();

            const ticketingLink = $('.ticketing-link-tracking');
            const ticketingLinkError = $('.ticketing-link-error');
            const trackingTextValue = ticketingLink.val() ?? '';
            
            const pageLink = $('#page-link');
            const pageLinkError = $('.page-link-error');
            const pageValue = pageLink.val() ?? '';

            let isValid = true;

            if (pageValue === '0') {
                pageLinkError.html('Veuillez sélectionner une page');
                pageLinkError.show();
                isValid = false;
            } else {
                pageLinkError.hide();
            }
        
            if (trackingTextValue.length < 1) {
                ticketingLinkError.html('Veuillez remplir le champ code de suivi');
                ticketingLinkError.show();
                isValid = false;
            } else if (trackingTextValue.length > 32) {
                ticketingLinkError.html('Le code de suivi doit comporter entre 1 et 32 caractères');
                ticketingLinkError.show();
                isValid = false;
            } else {
                ticketingLinkError.hide();
            }
        
            if (isValid) {
                $('.generated-ticketing-link').val(
                    ticketingLink.data('url') + (pageValue.length > 0 ? `/${pageValue}` : '') + '?from=' + trackingTextValue,
                );
                $('.generated-ticketing-link').focus();
                $('.generated-ticketing-link').select();

                $('#copy-generated-link-button').css('pointer-events', '');

                var qrButton = $('#download-generated-qrcode-button');
                var qrUrl = qrButton.data('url') + '?from=' + encodeURIComponent(trackingTextValue);
                if (pageValue.length > 0) {
                    qrUrl += '&page=' + encodeURIComponent(pageValue);
                }
                qrButton.attr('href', qrUrl);
                qrButton.css({ 'pointer-events': '', 'opacity': '' });
            }
        },
        copyGeneratedLink: function(e) {
            e.preventDefault();
            var generatedLink = $('.generated-ticketing-link');
            var copyButton = $('#copy-generated-link-button');
            generatedLink.select();
            document.execCommand('copy');
            copyButton.attr('aria-label', 'Lien copié');
            copyButton.children('i').removeClass('yp_font_copy').addClass('yp_font_checkmark');
            setTimeout(() => {
                copyButton.attr('aria-label', 'Copier le lien');
                copyButton.children('i').removeClass('yp_font_checkmark').addClass('yp_font_copy');
            }, 1500);
        },
        initWidgetStyleForm : function(e) {
            $("#ticketingWidgetStyleForm_primary_color").spectrum({
                preferredFormat: "hex",
                clickoutFiresChange: true,
                showInitial: true,
                showInput: true,
                chooseText: "Choisir",
                cancelText: "Annuler",
                showPalette: true,
                showSelectionPalette: true,
                palette: [],
                localStorageKey: "yurplan.spectrum"
            });
            $('#ticketingWidgetStyleForm_height_auto').on("change", function(e){
                if($(this).is(":checked")){
                    $('#widget_custom_height').hide()
                }
                else{
                    $('#widget_custom_height').show()
                }
            });
            $('#ticketingWidgetStyleForm_width_auto').on("change", function(e){
                if($(this).is(":checked")){
                    $('#widget_custom_width').hide()
                }
                else{
                    $('#widget_custom_width').show()
                }
            });
            $('#widgetEventStyleForm').submit(function(e){
                e.preventDefault();
                var form = $(this);
                var btn = form.find('button[type="submit"]');
                btn.addClass('c-btn--loading');
                btn.attr('disabled', 'disabled');
                $.post(
                    form.attr('action'),
                    form.serialize()
                ).done(function(){
                    window.location.reload();
                }).fail(function(){
                    btn.removeClass('c-btn--loading');
                    btn.removeAttr('disabled');
                });
                return false;
            });
        },
        toggleCguFields: function(urlOn) {
            if (urlOn === true) {
                $('.cgu_url_field').show();
                $('.cgu_url_name_field').show();
                $('.cgu_field').hide();
            }
            else {
                $('.cgu_url_field').hide();
                $('.cgu_url_name_field').hide();
                $('.cgu_field').show();
            }
        },
        initCguDisplayChoice: function() {
            if (cguDisplayChoice[0].checked === true) {
                YP.TicketingManager().toggleCguFields(false);
            }
            else {
                YP.TicketingManager().toggleCguFields(true);
            }

            cguDisplayChoice.on('change', function() {
                if (this.value == 0) {
                    YP.TicketingManager().toggleCguFields(false);
                }
                else {
                    YP.TicketingManager().toggleCguFields(true);
                }
            });
        },
    }
};

window.addEventListener("load", function(){
    YP.TicketingManager().init();
});
